/* Plinko popup. Markup and settings: sections/plk-popup.liquid.

   Steps: play (the ball always lands on the winning slot) -> email (Klaviyo, the
   market's list, profile locale = storefront language) -> thanks.

   When it opens
   - First show: N seconds on the page (5 by default, like Alia); on desktop also
     earlier when the mouse leaves the window. It waits for the cookie banner to
     be answered and never opens over the cart drawer or another overlay, nor on
     a page where the drawer was already opened.
   - After a close: a reopen widget on every page for the wait period (7 days),
     labelled with the prize once the visitor has won. One "second chance" per
     visitor in that period, only when they look like they are leaving, at least
     N seconds after the close: desktop = mouse leaves the window, mobile = quick
     flick back to the top (never on product pages).
   - Won but left without an email: it comes back at the email step, never a replay.
   - Signed up: never again (365 days). Drawer opened over it: steps aside, widget
     only, for the rest of the session.

   Test mode (for colleagues): ?plk=test turns it on for this browser session,
   across pages; ?plk=reset starts over as a new visitor; ?plk=off leaves.
   Same behaviour as a real visit, but its own memory, events marked qa, and the
   identity rules (Klaviyo-known, Alia, buyers, logged-in customers, email links)
   switched off. A small bar shows the state with Reset / Exit.
   &plk_variant=a|b picks the A/B variant in test mode.

   Events (Shopify Customer Events "cn_popup", forwarded by the custom pixel):
   shown (trigger time | exit | second_exit | second_flick | widget), play, won,
   submit, close, yield, teaser_open, error.
   The browser keeps only a small state object, never the email. */
(function () {
  'use strict';

  var EMAIL_SOURCES = ['klaviyo', 'email', 'sms', 'text'];
  var OVERLAYS = '.mobile-menu.is-open, .pcar-modal.is-open, .ph-glb.is-open, .phz.is-open, .awm.is-modal,' +
    ' .ceo-modal:not([hidden]), .prv-modal:not([hidden]), .prv-media:not([hidden])';
  var DAY = 864e5;
  var current = null;

  function num(v, fb) { var n = Number(v); return v === null || v === undefined || v === '' || isNaN(n) ? fb : n; }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode: this page only */ } }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  function parse(s) { try { return JSON.parse(s || '{}') || {}; } catch (e) { return {}; } }

  function readCfg(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function drop(el) { if (el && el.parentNode) el.parentNode.removeChild(el); }
  // A promo popup (form only, e.g. Black Friday) takes the game popup's place from its start to its end
  // time; outside that window the game popup runs as before. Decided in the browser, so a cached page
  // still switches on time. Test mode can force either one: ?plk_promo=on|off (auto = back to the dates).
  function promoActive(pcfg) {
    var force = (new URLSearchParams(window.location.search).get('plk_promo') || '').toLowerCase();
    if (force === 'auto') ssDel('cn_plk_promo');
    else if (force === 'on' || force === 'off') ssSet('cn_plk_promo', force);
    var forced = ssGet('cn_plk_test') === '1' || /[?&]plk=(test|force|reset)\b/.test(window.location.search) ? ssGet('cn_plk_promo') : null;
    if (forced === 'on') return true;
    if (forced === 'off') return false;
    var t = Date.now(), start = Date.parse(pcfg.start || ''), end = Date.parse(pcfg.end || '');
    return (isNaN(start) || t >= start) && (isNaN(end) || t < end);
  }
  function boot() {
    var root = document.querySelector('[data-plk]:not([data-plk-promo])');
    var cfg = readCfg(document.querySelector('[data-plk-config]'));
    var promoRoot = document.querySelector('[data-plk-promo]');
    var pcfg = readCfg(document.querySelector('[data-plk-config-promo]'));
    if (current) current.destroy();
    current = null;
    if (promoRoot && pcfg && promoActive(pcfg)) {
      drop(root);
      drop(document.querySelector('[data-plk-teaser=""]'));
      current = create(promoRoot, pcfg);
      return;
    }
    if (promoRoot) {
      drop(promoRoot);
      if (pcfg) drop(document.querySelector('[data-plk-teaser="' + pcfg.campaign + '"]'));
    }
    if (root && cfg) current = create(root, cfg);
  }

  function create(root, cfg) {
    var html = document.documentElement;
    var cleanups = [];
    function on(target, type, fn, opts) {
      if (!target) return;
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }
    var timers = [];
    function later(fn, ms) { var id = setTimeout(fn, ms); timers.push(id); return id; }
    var now = function () { return Date.now(); };

    var params = new URLSearchParams(window.location.search);
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
    var isProduct = /^product/.test(cfg.template || '');

    /* ---------- test mode ---------- */
    var qa = (params.get('plk') || '').toLowerCase();
    if (qa === 'off') ssDel('cn_plk_test');
    else if (qa === 'test' || qa === 'force' || qa === 'reset') ssSet('cn_plk_test', '1');
    var TEST = ssGet('cn_plk_test') === '1';
    // A promo popup keeps its own memory (cn_plk_<campaign>), apart from the game popup's (cn_plk).
    var MEM = cfg.promo ? '_' + cfg.campaign : '';
    var KEY = (TEST ? 'cn_plk_test' : 'cn_plk') + MEM;
    var SKEY = (TEST ? 'cn_plk_sess_test' : 'cn_plk_sess') + MEM;
    if (qa === 'reset') { lsDel(KEY); ssDel(SKEY); ssDel('cn_plk_tvar'); }
    var fvParam = (params.get('plk_variant') || '').toUpperCase();
    if (TEST && (fvParam === 'A' || fvParam === 'B')) ssSet('cn_plk_tvar', fvParam);
    // Drop the switches from the address so a reload or a shared link does not reset again.
    if (qa || fvParam || params.has('plk_promo')) {
      try {
        var clean = new URL(window.location.href);
        clean.searchParams.delete('plk');
        clean.searchParams.delete('plk_variant');
        clean.searchParams.delete('plk_promo');
        window.history.replaceState(window.history.state, '', clean.toString());
      } catch (e) {}
    }
    var EDITOR = !!cfg.editor || !!(window.Shopify && window.Shopify.designMode);
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    var IS_QA = TEST || EDITOR || (!!role && role !== 'main') || /\.myshopify\.com$/i.test(window.location.hostname);

    /* ---------- memory ---------- */
    var state = parse(lsGet(KEY));
    var sess = parse(ssGet(SKEY));
    function save(patch) {
      if (EDITOR) return;
      for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) state[k] = patch[k];
      lsSet(KEY, JSON.stringify(state));
      testBar();
    }
    function saveSess(patch) {
      if (EDITOR) return;
      for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) sess[k] = patch[k];
      ssSet(SKEY, JSON.stringify(sess));
    }
    function within(ts, days) { return !!ts && days > 0 && now() - ts < days * DAY; }
    var waitDays = num(cfg.freq && cfg.freq.dismissDays, 7);
    var subDays = num(cfg.freq && cfg.freq.submitDays, 365);
    // The wait after a close is over: start fresh (they may play again).
    if (state.windowStart && !within(state.windowStart, waitDays)) {
      save({ windowStart: 0, closedAt: 0, closedPath: '', closes: 0, second: 0, played: 0 });
    }
    var submitted = state.status === 'submitted' && (subDays <= 0 || within(state.at, subDays));

    /* ---------- A/B variant ---------- */
    var ab = cfg.ab || {};
    var test = ab.test || '';
    var variant = 'A';
    var V = {
      closeDelayMs: num(cfg.close && cfg.close.delayMs, 0),
      closeOnlyX: !!(cfg.close && cfg.close.onlyX),
      delayS: num(cfg.trigger && cfg.trigger.delayS, 5)
    };
    if (test && ab.b) {
      var tv = TEST ? ssGet('cn_plk_tvar') : null;
      if (tv === 'A' || tv === 'B') variant = tv;
      else if (state.test === test && (state.variant === 'A' || state.variant === 'B')) variant = state.variant;
      else { variant = Math.random() * 100 < clamp(num(ab.bPct, 50), 0, 100) ? 'B' : 'A'; save({ test: test, variant: variant }); }
      if (variant === 'B') {
        if (ab.b.closeDelayMs !== null && ab.b.closeDelayMs !== undefined) V.closeDelayMs = num(ab.b.closeDelayMs, V.closeDelayMs);
        if (ab.b.closeOnlyX !== null && ab.b.closeOnlyX !== undefined) V.closeOnlyX = !!ab.b.closeOnlyX;
        if (ab.b.delayS !== null && ab.b.delayS !== undefined) V.delayS = num(ab.b.delayS, V.delayS);
      }
    }

    /* ---------- elements ---------- */
    function q(sel) { return root.querySelector(sel); }
    // Variant B: its texts and board labels replace A's (empty B texts keep A's).
    var B = variant === 'B' && cfg.b ? cfg.b : null;
    function setLines(el, text) {
      el.textContent = '';
      String(text).split('\n').forEach(function (line, i) {
        if (i) el.appendChild(document.createElement('br'));
        el.appendChild(document.createTextNode(line));
      });
    }
    (function () {
      var slotsB = q('[data-plk-slots-b]');
      if (!B) { if (slotsB) slotsB.parentNode.removeChild(slotsB); return; }
      var keys = { title: 'title', play: 'play', win_title: 'winTitle', email_text: 'emailText', submit: 'submit', ty_title: 'tyTitle', ty_text: 'tyText' };
      Array.prototype.forEach.call(root.querySelectorAll('[data-plk-t]'), function (el) {
        var v = B[keys[el.getAttribute('data-plk-t')]];
        if (v) setLines(el, v);
      });
      if (slotsB && B.slots > 0) {
        var slotsA = q('[data-plk-slots]');
        slotsA.parentNode.removeChild(slotsA);
        slotsB.removeAttribute('data-plk-slots-b');
        slotsB.setAttribute('data-plk-slots', '');
        slotsB.hidden = false;
        var bd = q('[data-plk-board]');
        if (bd && bd.getAttribute('data-label-b')) bd.setAttribute('aria-label', bd.getAttribute('data-label-b'));
      }
    })();
    // The game this visitor plays (set per variant): Plinko or a scratch card. Drop the other one.
    var GAME = (cfg.games && cfg.games[variant]) || 'plinko';
    if (cfg.layouts && cfg.layouts[variant]) root.setAttribute('data-layout', cfg.layouts[variant]);
    Array.prototype.forEach.call(root.querySelectorAll('[data-plk-game]'), function (el) {
      if (el.getAttribute('data-plk-game') !== GAME) el.parentNode.removeChild(el);
    });
    var closeBtn = q('[data-plk-close]');
    var playBtn = q('[data-plk-play]');
    var board = q('[data-plk-board]');
    var form = q('[data-plk-form]');
    var emailIn = q('[data-plk-email]');
    var PH = cfg.phone || null;
    var pForm = q('[data-plk-pform]');
    var phoneIn = q('[data-plk-phone]');
    var ccSel = q('[data-plk-cc]');
    var pErr = q('[data-plk-perr]');
    var pSubmit = q('[data-plk-psubmit]');
    var skipBtn = q('[data-plk-skip]');
    if (!pForm || !phoneIn) PH = null;
    var errEl = q('[data-plk-err]');
    var submitBtn = q('[data-plk-submit]');
    var doneBtn = q('[data-plk-done]');
    var steps = root.querySelectorAll('[data-plk-step]');
    var host = root.closest('.shopify-section') || root.parentNode;
    var widget = host ? host.querySelector('[data-plk-teaser="' + (cfg.promo ? cfg.campaign : '') + '"]') : null;
    var widgetLabel = widget ? widget.querySelector('[data-plk-teaser-label]') : null;
    var W = cfg.widget || {};
    if (B) W = { on: W.on, label: B.teaser || W.label, labelWon: B.teaserWon || W.labelWon, idleS: W.idleS };

    /* ---------- tracking (Shopify Customer Events -> custom pixel) ---------- */
    var refHost = '';
    try { refHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      var v = params.get(k);
      if (v) utm[k] = v.slice(0, 120);
    });
    var queue = [];
    var flushTimer = 0;
    var flushTries = 0;
    function publish(d) {
      try {
        var a = window.Shopify && window.Shopify.analytics;
        if (a && typeof a.publish === 'function') { a.publish('cn_popup', d); return true; }
      } catch (e) {}
      return false;
    }
    // Shopify.analytics can arrive after this script; hold events until it does.
    function flush() {
      flushTimer = 0;
      while (queue.length && publish(queue[0])) queue.shift();
      if (queue.length && flushTries++ < 60) flushTimer = setTimeout(flush, 500);
    }
    var step = 'play';
    function track(type, extra) {
      var d = {
        type: type, popup: cfg.campaign, test: test, variant: variant, market: cfg.market,
        host: window.location.hostname.replace(/^www\./, ''), template: cfg.template, page: window.location.pathname,
        device: isMobile ? 'mobile' : 'desktop', step: step, views: state.seen || 0, qa: IS_QA, ref: refHost, ts: now()
      };
      var k;
      for (k in utm) d[k] = utm[k];
      if (extra) for (k in extra) d[k] = extra[k];
      queue.push(d);
      if (!flushTimer) flush();
    }

    /* ---------- who never sees it (off in test mode) ---------- */
    function emailTraffic() {
      var src = (params.get('utm_source') || '').toLowerCase();
      var med = (params.get('utm_medium') || '').toLowerCase();
      return EMAIL_SOURCES.indexOf(src) > -1 || EMAIL_SOURCES.indexOf(med) > -1 || params.has('_kx');
    }
    // Alia stores each visitor's popup progress in localStorage (user-flow-v2-<id>);
    // a thank-you step in there means they submitted their email through Alia.
    function aliaSignedUp() {
      var done = (cfg.skip && cfg.skip.aliaSteps) || [];
      if (!done.length) return false;
      try {
        var ls = window.localStorage;
        for (var i = 0; i < ls.length; i++) {
          var k = ls.key(i);
          if (!k || k.indexOf('user-flow-v2-') !== 0) continue;
          var raw = ls.getItem(k) || '';
          for (var j = 0; j < done.length; j++) if (raw.indexOf(done[j]) !== -1) return true;
        }
      } catch (e) {}
      return false;
    }
    // Klaviyo's own cookie carries an exchange id or email once the browser is identified.
    function klaCookieKnown() {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return false;
      try { return /"\$(exchange_id|email|phone_number)"/.test(window.atob(decodeURIComponent(m[1]))); } catch (e) { return false; }
    }
    // The same check Alia uses: klaviyo.isIdentified(). Unknown after 2.5 s = not known.
    function klaviyoKnown() {
      if (TEST || !(cfg.skip && cfg.skip.klaviyoKnown)) return Promise.resolve(false);
      if (klaCookieKnown()) return Promise.resolve(true);
      return new Promise(function (resolve) {
        var done = false;
        var waited = 0;
        function fin(v) { if (!done) { done = true; resolve(!!v); } }
        later(function () { fin(false); }, 2500);
        (function poll() {
          var k = window.klaviyo;
          if (k && typeof k.isIdentified === 'function') {
            try { Promise.resolve(k.isIdentified()).then(fin, function () { fin(false); }); } catch (e) { fin(false); }
            return;
          }
          if ((waited += 200) < 2400) later(poll, 200);
        })();
      });
    }
    function identitySkip() {
      if (TEST || EDITOR) return null;
      var sk = cfg.skip || {};
      var cu = cfg.customer || {};
      var path = window.location.pathname.toLowerCase();
      var bare = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/, '');
      var i;
      if (/^\/(cart|checkouts?|account)(\/|$)/.test(bare)) return 'page';
      for (i = 0; i < (sk.paths || []).length; i++) if (sk.paths[i] && path.indexOf(sk.paths[i]) !== -1) return 'path';
      for (i = 0; i < (sk.params || []).length; i++) if (params.has(sk.params[i])) return 'param';
      if (sk.emailTraffic && emailTraffic()) { save({ known: now() }); return 'email_link'; }
      if (sk.aliaSigned && aliaSignedUp()) { save({ known: now() }); return 'alia'; }
      // A promo popup that skips subscribers also skips people who signed up through the game popup.
      if (sk.gameSigned) {
        var g = parse(lsGet('cn_plk'));
        if (g.status === 'submitted' && (subDays <= 0 || within(g.at, subDays))) return 'game_signed';
      }
      if (state.known && within(state.known, 365)) return 'known';
      if (sk.buyers && (cu.orders > 0 || /(?:^|;\s*)cn_buyer=1/.test(document.cookie))) return 'buyer';
      if (sk.klaviyoKnown && cu.marketing) return 'subscriber';
      if (isMobile ? !(cfg.trigger && cfg.trigger.mobile) : !(cfg.trigger && cfg.trigger.desktop)) return 'device';
      return null;
    }

    /* ---------- other overlays ---------- */
    function visible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      if (r.width < 2 && r.height < 2) return false;
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
    }
    function blocked() {
      if (html.classList.contains('cd-locked')) return 'drawer';
      var list = document.querySelectorAll(OVERLAYS);
      for (var i = 0; i < list.length; i++) if (visible(list[i])) return 'overlay';
      var b = document.body;
      if (html.style.overflow === 'hidden' || (b && (b.style.overflow === 'hidden' || b.style.position === 'fixed'))) return 'overlay';
      return null;
    }
    function bannerUp() {
      var list = document.querySelectorAll('#pandectes-banner .cc-window, .cc-window.cc-banner');
      for (var i = 0; i < list.length; i++) if (!list[i].classList.contains('cc-invisible') && visible(list[i])) return true;
      return false;
    }
    var open = false;
    var drawerSeen = html.classList.contains('cd-locked');
    var mo = new MutationObserver(function () {
      if (!html.classList.contains('cd-locked')) return;
      drawerSeen = true;
      if (open) yieldToDrawer();
    });
    mo.observe(html, { attributes: true, attributeFilter: ['class'] });
    cleanups.push(function () { mo.disconnect(); });

    /* ---------- show / hide ---------- */
    var shownThisPage = false;
    var lastFocus = null;
    var prevOverflow = '';
    var closeReady = true;
    var closeTimer = 0;
    function setStep(s) {
      step = s;
      for (var i = 0; i < steps.length; i++) steps[i].hidden = steps[i].getAttribute('data-plk-step') !== s;
      root.setAttribute('data-step', s);
      root.setAttribute('aria-labelledby', (cfg.promo ? 'plkbf-title-' : 'plk-title-') + s);
      testBar();
    }
    function show(trigger) {
      if (open) return;
      open = true;
      shownThisPage = true;
      hideWidget();
      setStep(submitted ? 'thanks' : (state.played || GAME === 'none' ? 'email' : 'play'));
      root.hidden = false;
      lastFocus = document.activeElement;
      prevOverflow = html.style.overflow;
      html.style.overflow = 'hidden';
      html.classList.add('plk-open');
      clearTimeout(closeTimer);
      closeReady = !(V.closeDelayMs > 0);
      if (closeReady) closeBtn.removeAttribute('data-wait');
      else {
        closeBtn.setAttribute('data-wait', '');
        closeTimer = setTimeout(function () { closeReady = true; closeBtn.removeAttribute('data-wait'); }, V.closeDelayMs);
      }
      void root.offsetWidth;            // start the fade from opacity 0
      root.classList.add('is-open');
      try { root.focus({ preventScroll: true }); } catch (e) {}
      if (step === 'play') game.start();
      save({ seen: (state.seen || 0) + 1, lastSeen: now() });
      track('shown', { trigger: trigger });
    }
    // Phones: the on-screen keyboard covers the bottom of a full-screen popup without resizing it
    // (iOS keeps the layout viewport). While it is up, size the popup to the visible area (visualViewport)
    // and switch to a compact top-aligned layout so the email field and button stay above the keyboard.
    var vv = window.visualViewport;
    function fitViewport() {
      if (!vv) return;
      var full = html.clientHeight || window.innerHeight;
      var kb = open && full - vv.height > 120;
      if (kb) {
        root.style.top = Math.round(vv.offsetTop) + 'px';
        root.style.height = Math.round(vv.height) + 'px';
        root.style.bottom = 'auto';
      } else {
        root.style.top = root.style.height = root.style.bottom = '';
      }
      root.classList.toggle('plk--kb', !!kb);
    }
    if (vv) { on(vv, 'resize', fitViewport); on(vv, 'scroll', fitViewport); }
    [emailIn, phoneIn].forEach(function (inp) {
      if (!inp) return;
      on(inp, 'focus', function () {
        later(function () {
          fitViewport();
          try { inp.scrollIntoView({ block: 'center' }); } catch (e) {}
        }, 300);
      });
      on(inp, 'blur', function () { later(fitViewport, 300); });
    });

    function hide() {
      if (!open) return;
      open = false;
      fitViewport();
      root.classList.remove('is-open');
      html.classList.remove('plk-open');
      html.style.overflow = prevOverflow;
      clearTimeout(closeTimer);
      game.pause();
      later(function () { if (!open) root.hidden = true; }, 380);
      if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    function dismiss(method) {
      if (!open) return;
      if (step !== 'thanks' && !closeReady && method !== 'done') return;
      var wasStep = step;
      hide();
      track('close', { method: method });
      if (wasStep === 'thanks' || wasStep === 'phone') return;   // signed up: no widget, no second chance
      var t = now();
      save({ closedAt: t, windowStart: state.windowStart || t, closedPath: window.location.pathname, closes: (state.closes || 0) + 1 });
      showWidget(600);
      armSecondChance();
    }
    function yieldToDrawer() {
      hide();
      saveSess({ yield: 1 });
      track('yield');
      showWidget(400);
    }

    on(closeBtn, 'click', function () { dismiss('x'); });
    on(root, 'click', function (e) {
      if (V.closeOnlyX) return;
      var t = e.target;
      if (t === root || (t.classList && t.classList.contains('plk__veil')) || t.hasAttribute('data-plk-scroll') || t.hasAttribute('data-plk-inner')) dismiss('backdrop');
    });
    function focusables() {
      return Array.prototype.filter.call(root.querySelectorAll('button, input, select, a[href], [tabindex]:not([tabindex="-1"])'), function (el) {
        return !el.disabled && !el.closest('[hidden]') && !el.hasAttribute('data-wait') && el.getClientRects().length > 0;
      });
    }
    on(document, 'keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { if (!V.closeOnlyX) dismiss('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || a === root || !root.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !root.contains(a))) { e.preventDefault(); first.focus(); }
    });

    /* ---------- the game ---------- */
    var SC = cfg.scratch || {};
    var game = GAME === 'none'
      ? { start: function () {}, pause: function () {}, idle: function () { return true; }, drop: function () {} }
      : GAME === 'scratch'
      ? createScratch({
          card: q('[data-plk-scard]'), canvas: q('[data-plk-scratch]'), cover: SC.cover, label: SC.label,
          brush: SC.brush, pct: SC.pct, onStart: function () { track('play'); }, onWin: onWin
        })
      : createGame({
          board: board, canvas: q('[data-plk-canvas]'), slots: q('[data-plk-slots]'),
          rows: cfg.game && cfg.game.rows, speed: cfg.game && cfg.game.speed, win: (B && B.slots > 0 && B.win) || (cfg.game && cfg.game.win),
          confetti: !!(cfg.game && cfg.game.confetti), reduceMotion: reduceMotion,
          isOpen: function () { return open; }, onWin: onWin
        });
    function drop() {
      if (GAME !== 'plinko' || step !== 'play' || !game.idle()) return;
      if (playBtn) playBtn.disabled = true;
      track('play');
      game.drop();
    }
    function onWin() {
      save({ played: 1, playedAt: now() });
      track('won');
      later(function () {
        if (!open || step !== 'play') return;   // closed meanwhile: they come back to the email step
        setStep('email');
        if (!isMobile) { try { emailIn.focus({ preventScroll: true }); } catch (e) {} }
      }, reduceMotion ? 300 : Math.max(0, num(cfg.game && cfg.game.pauseMs, 1500)));
    }
    on(playBtn, 'click', drop);
    on(board, 'click', drop);

    /* ---------- email ---------- */
    var T = cfg.t || {};
    function fail(msg) {
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
      if (msg) { emailIn.setAttribute('aria-invalid', 'true'); try { emailIn.focus({ preventScroll: true }); } catch (e) {} }
      else emailIn.removeAttribute('aria-invalid');
    }
    function noteCart() {
      if (!cfg.cartAttr) return;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var note = [cfg.campaign, variant, cfg.market, new Date().toISOString().slice(0, 10)].join('|');
      try {
        fetch(base + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { _cn_popup: note } })
        }).catch(function () {});
      } catch (e) {}
    }
    // Every successful sign-up also records a Klaviyo event, "Popup Submitted", new or already
    // subscribed alike: list-join flows only start for people new to the list, an event-triggered
    // flow reaches everyone. Properties identify the campaign, market, variant, prize and test.
    // The page's full address, so emails can send people back to where they signed up. Only the
    // parameters that define the page stay (a product's variant or plan, search, sorting, filters);
    // tracking, referral, A/B and preview parameters go.
    function pageUrl() {
      try {
        var u = new URL(window.location.href);
        var drop = [];
        u.searchParams.forEach(function (v, key) {
          if (!/^(variant|selling_plan|page|q|type|sort_by)$|^filter\./.test(key)) drop.push(key);
        });
        drop.forEach(function (key) { u.searchParams.delete(key); });
        u.hash = '';
        return u.toString();
      } catch (e) { return window.location.origin + window.location.pathname; }
    }
    function eventProps() {
      var slotsEl = q('[data-plk-slots]');
      var winIdx = ((B && B.slots > 0 && B.win) || (cfg.game && cfg.game.win) || 1) - 1;
      var prize = GAME === 'scratch' ? (SC.prize || '')
        : (slotsEl && slotsEl.children[winIdx] ? slotsEl.children[winIdx].textContent.replace(/\s+/g, ' ').trim() : '');
      return {
        'Popup campaign': cfg.campaign, 'Popup market': cfg.market, 'Popup variant': variant, 'Popup test': test || null, 'Popup game': GAME,
        'Prize': prize, 'Page': window.location.pathname, 'Page URL': pageUrl(), 'Domain': window.location.hostname.replace(/^www\./, ''),
        'Locale': cfg.locale || null, 'QA': !!IS_QA
      };
    }
    function klaviyoEvent(email, uid) {
      var k = cfg.klaviyo || {};
      if (!k.company) return;
      var body = { data: { type: 'event', attributes: {
        properties: eventProps(),
        unique_id: uid,
        metric: { data: { type: 'metric', attributes: { name: 'Popup Submitted' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } }
      } } };
      try {
        fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(k.company), {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-10-15' },
          body: JSON.stringify(body)
        }).then(function (res) { if (!(res.status === 202 || res.ok)) track('error', { reason: 'klaviyo_event_' + res.status }); })
          .catch(function () {});
      } catch (e) {}
    }
    // fetch that gives up after ms (a blocked request can hang instead of failing).
    function post(url, opts, ms) {
      var ctl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms) : 0;
      if (ctl) opts.signal = ctl.signal;
      return fetch(url, opts).then(function (res) { clearTimeout(timer); return res; },
        function (e) { clearTimeout(timer); throw e; });
    }
    // One Klaviyo client subscription (email step or phone step). A refusal rejects with .status and
    // .why; a network error, timeout, 429 or 5xx rejects with .retry (our server may still get through).
    function kSubscribe(attrs) {
      var k = cfg.klaviyo || {};
      var payload = { data: { type: 'subscription',
        attributes: { custom_source: k.source || 'Plinko popup', profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: k.list } } } } };
      return post('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(k.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-10-15' },
        body: JSON.stringify(payload)
      }, 8000).then(function (res) {
        if (res.status === 202 || res.ok) return;
        return res.text().then(function (t) {
          var why = '';
          try { why = (((JSON.parse(t).errors || [])[0]) || {}).detail || ''; } catch (e) { why = String(t || '').slice(0, 80); }
          var x = new Error('http_' + res.status + (why ? ': ' + why : ''));
          x.status = res.status;
          x.why = why;
          x.retry = res.status === 429 || res.status >= 500;
          throw x;
        });
      }, function (err) {
        var x = new Error('blocked: ' + String((err && err.message) || err));
        x.retry = true;
        throw x;
      });
    }
    // When the browser cannot reach Klaviyo (VPNs and ad blockers block a.klaviyo.com), the sign-up
    // goes to our server, which passes it to Klaviyo: first through the shop's own domain (the cart
    // app proxy, which blockers leave alone), then to analytics.cannumo.io directly.
    var RELAYS = (cfg.klaviyo && cfg.klaviyo.relay) || ['/apps/cart/subscribe', 'https://analytics.cannumo.io/subscribe'];
    // Our server, route by route; a refusal of the email or number itself stops (it would repeat everywhere).
    function relay(body, i, last) {
      if (!RELAYS[i]) return Promise.reject(last);
      return post(RELAYS[i], {
        method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body)
      }, 15000).then(function (res) {
        return res.text().then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (e) {}
          if (res.ok && j && j.ok) return j;
          var x = new Error('server_' + res.status + (j && (j.detail || j.error) ? ': ' + (j.detail || j.error) : ''));
          x.final = res.status === 400 && !!j && (j.error === 'email' || j.error === 'phone' || j.error === 'klaviyo');
          x.badPhone = !!j && j.error === 'phone';
          throw x;
        });
      }, function (err) {
        throw new Error('server unreachable: ' + String((err && err.message) || err));
      }).catch(function (err) {
        return err.final ? Promise.reject(err) : relay(body, i + 1, err);
      });
    }
    function viaServer(first, body) {
      return relay(body, 0, first).catch(function (err2) {
        var x = new Error(String(first.message) + ' / ' + String((err2 && err2.message) || err2));
        x.badPhone = !!(err2 && err2.badPhone);
        throw x;
      });
    }
    function toThanks() {
      setStep('thanks');
      try { (doneBtn || closeBtn).focus({ preventScroll: true }); } catch (e) {}
    }

    var lastEmail = '';
    var lastProps = null;
    // A promo sign-up also counts in the listed popups' memory ('' = the game popup), so they never
    // show to this visitor later (e.g. Plinko after Black Friday).
    function markOthers() {
      if (EDITOR) return;
      (cfg.alsoMark || []).forEach(function (name) {
        var key = (TEST ? 'cn_plk_test' : 'cn_plk') + (name ? '_' + name : '');
        if (key === KEY) return;
        var st = parse(lsGet(key));
        st.status = 'submitted';
        st.at = now();
        lsSet(key, JSON.stringify(st));
      });
    }
    on(emailIn, 'input', function () { if (!errEl.hidden) fail(''); });
    on(form, 'submit', function (e) {
      e.preventDefault();
      var email = (emailIn.value || '').trim();
      if (!email) { fail(T.required); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fail(T.invalid); return; }
      fail('');
      var k = cfg.klaviyo || {};
      if (!k.company || !k.list) { fail(T.server); track('error', { reason: 'config' }); return; }
      submitBtn.disabled = true;
      root.setAttribute('aria-busy', 'true');
      var uid = 'plk-' + now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var profileProps = { 'Popup campaign': cfg.campaign, 'Popup market': cfg.market, 'Popup variant': variant };
      // Alia put Shopify Tags on every profile, and flow filters such as "Shopify Tags doesn't contain ..."
      // skip profiles without that property, so the popup can set it too (setting per store).
      var tags = String(k.tags || '').replace(/\{game\}/g, GAME === 'scratch' ? 'Scratch off' : 'Plinko').split(',')
        .map(function (t) { return t.trim(); }).filter(Boolean);
      if (tags.length) profileProps['Shopify Tags'] = tags;
      // The storefront language (lt / lv / et / en) goes on the profile as its locale, the same
      // short form Alia's sign-ups carry, so Klaviyo segments and flows keyed on locale keep working.
      function subscribe(withLocale) {
        var attrs = { email: email, properties: profileProps, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
        if (withLocale && cfg.locale) attrs.locale = cfg.locale;
        return kSubscribe(attrs).catch(function (err) {
          // A rejected locale must never cost the sign-up: try once more without it.
          if (withLocale && cfg.locale && err.status === 400) { track('error', { reason: 'locale_rejected' }); return subscribe(false); }
          throw err;
        });
      }
      var via = 'klaviyo';
      subscribe(true).then(function () {
        klaviyoEvent(email, uid);
      }, function (err) {
        if (!err || !err.retry) throw err;
        via = 'server';
        return viaServer(err, {
          company: k.company, list: k.list, email: email, locale: cfg.locale || null, source: k.source || 'Plinko popup',
          device: isMobile ? 'mobile' : 'desktop', profile: profileProps, event: { unique_id: uid, properties: eventProps() }
        });
      }).then(function () {
        submitted = true;
        lastEmail = email;
        lastProps = profileProps;
        save({ status: 'submitted', at: now() });
        markOthers();
        hideWidget();
        track('submit', { method: via });
        if (cfg.lead) {
          try { if (window.fbq) window.fbq('track', 'Lead', { content_name: cfg.campaign }); } catch (e5) {}
          try { if (window.gtag) window.gtag('event', 'generate_lead', { method: k.source || cfg.campaign }); } catch (e6) {}
        }
        try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (e3) {}
        noteCart();
        // Optional phone step; skipping or closing it never brings the popup back (the email is in).
        if (PH && pForm) {
          setStep('phone');
          track('phone_view');
          if (!isMobile) { try { phoneIn.focus({ preventScroll: true }); } catch (e4) {} }
        } else toThanks();
      }).catch(function (err) {
        var why = String((err && err.message) || err).slice(0, 160);
        // Test mode shows the technical reason after the message; visitors see the message only.
        fail(T.server + (IS_QA ? ' [' + why + ']' : ''));
        track('error', { reason: why.slice(0, 60) });
      }).then(function () {
        submitBtn.disabled = false;
        root.removeAttribute('aria-busy');
      });
    });

    /* ---------- phone (optional step after the email) ---------- */
    // Dial codes offered in the country picker; the market's own country comes first.
    var DIAL = { GB: '44', IE: '353', US: '1', CA: '1', AU: '61', NZ: '64', FR: '33', DE: '49', ES: '34', IT: '39', NL: '31',
      BE: '32', PT: '351', AT: '43', CH: '41', DK: '45', SE: '46', NO: '47', FI: '358', PL: '48', LT: '370', LV: '371', EE: '372' };
    function flagOf(cc) {
      try { return String.fromCodePoint(0x1F1E6 + cc.charCodeAt(0) - 65, 0x1F1E6 + cc.charCodeAt(1) - 65); } catch (e) { return cc; }
    }
    // Whatever way the number is typed, Klaviyo gets E.164: with GB picked, 07572102091, 7572102091,
    // 447572102091, 0044 7572 102091, +44 (0)7572 102091 and +447572102091 all become +447572102091.
    function toE164(raw, cc) {
      var dial = DIAL[cc] || '';
      var s = String(raw || '').replace(/\(0\)/g, '').replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');
      if (s.slice(0, 2) === '00') s = '+' + s.slice(2);
      if (s.charAt(0) !== '+') {
        if (dial && dial !== '1' && s.indexOf(dial) === 0 && s.length - dial.length >= 9) s = '+' + s;
        else if (dial === '1' && s.length === 11 && s.charAt(0) === '1') s = '+' + s;
        else s = '+' + dial + s.replace(cc === 'LT' ? /^[08]/ : /^0+/, '');   // Lithuanian numbers may start with 8
      }
      // "+44 07..." keeps the national 0 after the country code: drop it.
      if (dial && dial !== '1' && s.indexOf('+' + dial + '0') === 0) s = '+' + dial + s.slice(dial.length + 2);
      if (!/^\+[1-9]\d{7,14}$/.test(s)) return '';
      if (s.indexOf('+44') === 0 && !/^\+447\d{9}$/.test(s)) return '';      // UK: mobiles only (07...)
      if (s.indexOf('+370') === 0 && !/^\+3706\d{7}$/.test(s)) return '';   // LT: mobiles only (86..., 06..., +3706...)
      if (s.indexOf('+1') === 0 && !/^\+1[2-9]\d{9}$/.test(s)) return '';
      return s;
    }
    if (PH && ccSel) {
      var firstCc = DIAL[PH.country] ? PH.country : 'GB';
      [firstCc].concat(Object.keys(DIAL).filter(function (c) { return c !== firstCc; })).forEach(function (c) {
        var o = document.createElement('option');
        o.value = c;
        o.textContent = flagOf(c) + ' +' + DIAL[c];
        ccSel.appendChild(o);
      });
    }
    function pfail(msg) {
      if (!pErr) return;
      pErr.textContent = msg || '';
      pErr.hidden = !msg;
      if (msg) { phoneIn.setAttribute('aria-invalid', 'true'); try { phoneIn.focus({ preventScroll: true }); } catch (e) {} }
      else phoneIn.removeAttribute('aria-invalid');
    }
    // "Popup phone" on the profile: given or skipped (closing the tab on this step leaves it unset),
    // so email and SMS flows and segments can split on the phone step at any time.
    function phoneProps(answer) {
      var o = {}, key;
      for (key in (lastProps || {})) o[key] = lastProps[key];
      o['Popup phone'] = answer;
      return o;
    }
    // "Popup Phone Submitted": the phone step's own event, like "Popup Submitted" for the email,
    // with the SMS consent result. Sent by our server instead when the browser cannot reach Klaviyo.
    function phoneEvent(phone, consent, uid) {
      var k = cfg.klaviyo || {};
      if (!k.company) return;
      var props = eventProps();
      props['SMS consent'] = consent;
      try {
        fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(k.company), {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-10-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: {
            properties: props, unique_id: uid,
            metric: { data: { type: 'metric', attributes: { name: 'Popup Phone Submitted' } } },
            profile: { data: { type: 'profile', attributes: { email: lastEmail, phone_number: phone } } }
          } } })
        }).then(function (res) { if (!(res.status === 202 || res.ok)) track('error', { reason: 'klaviyo_phone_event_' + res.status }); })
          .catch(function () {});
      } catch (e) {}
    }
    on(skipBtn, 'click', function () {
      track('phone_skip');
      toThanks();
      // In the background: the visitor is already on the thank-you step, a failure only leaves it unset.
      var k = cfg.klaviyo || {};
      if (!lastEmail || !k.company) return;
      var props = phoneProps('skipped');
      kSubscribe({ email: lastEmail, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } })
        .catch(function (err) {
          if (!err || !err.retry) throw err;
          return relay({ company: k.company, list: k.list, email: lastEmail, source: k.source || 'Plinko popup',
            device: isMobile ? 'mobile' : 'desktop', profile: props, phone_skip: true }, 0, err);
        })
        .catch(function () {});
    });
    on(phoneIn, 'input', function () { if (pErr && !pErr.hidden) pfail(''); });
    on(pForm, 'submit', function (e) {
      e.preventDefault();
      var PT = (PH && PH.t) || {};
      if (!(phoneIn.value || '').trim()) { pfail(PT.required || T.required); return; }
      var phone = toE164(phoneIn.value, ccSel ? ccSel.value : (PH.country || 'GB'));
      if (!phone) { pfail(PT.invalid || T.invalid); track('phone_invalid', { reason: 'format' }); return; }
      pfail('');
      var k = cfg.klaviyo || {};
      pSubmit.disabled = true;
      root.setAttribute('aria-busy', 'true');
      var smsRefused = '';
      var puid = 'plk-' + now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      // With SMS consent when the setting asks for it; if Klaviyo refuses the consent itself (for
      // example SMS not set up for that country), the number is still saved on the profile.
      function attrs(withSms) {
        return { email: lastEmail, phone_number: phone, properties: phoneProps('given'),
          subscriptions: withSms ? { sms: { marketing: { consent: 'SUBSCRIBED' } } } : { email: { marketing: { consent: 'SUBSCRIBED' } } } };
      }
      function badNumber(why) { return /phone/i.test(why || '') && /invalid|format|valid/i.test(why || ''); }
      function send(withSms) {
        return kSubscribe(attrs(withSms)).catch(function (err) {
          if (withSms && err.status === 400 && !badNumber(err.why)) { smsRefused = err.why || 'refused'; return send(false); }
          if (err.status === 400 && badNumber(err.why)) err.badPhone = true;
          throw err;
        });
      }
      var via = 'klaviyo';
      send(!!PH.sms).then(null, function (err) {
        if (!err || !err.retry) throw err;
        via = 'server';
        return viaServer(err, {
          company: k.company, list: k.list, email: lastEmail, phone: phone, sms: !!PH.sms, source: k.source || 'Plinko popup',
          device: isMobile ? 'mobile' : 'desktop', profile: phoneProps('given'), test: test || null, qa: !!IS_QA,
          event: { unique_id: puid, properties: eventProps() }
        }).then(function (j) { if (j && j.sms === false) smsRefused = j.detail || 'refused'; });
      }).then(function () {
        if (smsRefused) track('error', { reason: ('sms_refused: ' + smsRefused).slice(0, 60) });
        if (via === 'klaviyo') phoneEvent(phone, !PH.sms ? 'not asked' : (smsRefused ? 'refused' : 'granted'), puid);
        track('phone_submit', { method: via });
        toThanks();
      }).catch(function (err) {
        if (err && err.badPhone) { pfail(PT.invalid || T.invalid); track('phone_invalid', { reason: 'klaviyo' }); return; }
        var why = String((err && err.message) || err).slice(0, 160);
        pfail(T.server + (IS_QA ? ' [' + why + ']' : ''));
        track('error', { reason: why.slice(0, 60) });
      }).then(function () {
        pSubmit.disabled = false;
        root.removeAttribute('aria-busy');
      });
    });
    on(doneBtn, 'click', function () { dismiss('done'); });

    /* ---------- reopen widget ---------- */
    var idleBounced = false;
    var lastMove = now();
    function showWidget(delay) {
      if (!widget || !W.on || submitted) return;
      later(function () {
        if (open || submitted) return;
        var label = state.played ? (W.labelWon || W.label) : W.label;
        if (widgetLabel) widgetLabel.textContent = label || '';
        widget.setAttribute('aria-label', label || '');
        // Theme previews have Shopify's bar along the bottom; sit above it so testers see the widget.
        widget.classList.toggle('plk-widget--preview', !!role && role !== 'main');
        widget.hidden = false;
        liftWidget();
        void widget.offsetWidth;
        widget.classList.add('is-in');
      }, delay || 0);
    }
    // The product page's sticky add-to-cart bar runs along the bottom: sit just above it, never under it.
    var satcBar = document.querySelector('.satc');
    function liftWidget() {
      if (!widget || widget.hidden) return;
      var lift = 0;
      if (satcBar && satcBar.classList.contains('is-visible')) {
        var r = satcBar.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight) lift = Math.round(window.innerHeight - r.top) + 12;
      }
      if (lift && !!role && role !== 'main') lift = Math.max(lift, 84);
      widget.style.bottom = lift ? lift + 'px' : '';
    }
    if (satcBar) {
      var satcMo = new MutationObserver(liftWidget);
      satcMo.observe(satcBar, { attributes: true, attributeFilter: ['class', 'style'] });
      cleanups.push(function () { satcMo.disconnect(); });
    }
    on(window, 'resize', liftWidget);
    function hideWidget() {
      if (!widget) return;
      widget.classList.remove('is-in', 'is-bounce');
      widget.hidden = true;
    }
    on(widget, 'click', function () { track('teaser_open'); show('widget'); });
    // Desktop: one gentle bounce per page after a while without mouse movement.
    if (!isMobile && widget && num(W.idleS, 0) > 0) {
      on(document, 'mousemove', function () { lastMove = now(); });
      var idleIv = setInterval(function () {
        if (idleBounced || open || widget.hidden || document.visibilityState !== 'visible') return;
        if (now() - lastMove >= num(W.idleS, 12) * 1000) {
          idleBounced = true;
          widget.classList.add('is-bounce');
          later(function () { widget.classList.remove('is-bounce'); }, 900);
        }
      }, 1000);
      cleanups.push(function () { clearInterval(idleIv); });
    }

    /* ---------- opening ---------- */
    // Waits for the cookie answer (or at most cookieWaitS, then opens above the banner),
    // for overlays to close, and checks Klaviyo once more right before opening.
    function attempt(trigger, onShown) {
      if (open || shownThisPage) return;
      var waitS = num(cfg.trigger && cfg.trigger.cookieWaitS, 0);
      var bannerDeadline = waitS > 0 ? now() + waitS * 1000 : Infinity;
      (function tick() {
        if (open || shownThisPage) return;
        if (drawerSeen) return;                        // shopping already: not on this page
        if (blocked() || (bannerUp() && now() < bannerDeadline)) { later(tick, 400); return; }
        klaviyoKnown().then(function (known) {
          if (known) { save({ known: now() }); hideWidget(); return; }
          if (open || shownThisPage || drawerSeen) return;
          if (blocked()) { later(tick, 400); return; }
          root.classList.toggle('plk--over-banner', bannerUp());
          show(trigger);
          if (onShown) onShown();
        });
      })();
    }
    function exitIntent(fn, minMs) {
      var since = now();
      on(document, 'mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0 && now() - since >= minMs) fn();
      });
    }
    // First show: N seconds on the page (+ scroll if set); desktop also on exit intent.
    function armFirst() {
      var t0 = now();
      var need = clamp(num(cfg.trigger && cfg.trigger.scrollPct, 0), 0, 100);
      var delay = Math.max(0, V.delayS) * 1000;
      var maxPct = 0;
      var fired = false;
      function pct() {
        var h = Math.max(html.scrollHeight, document.body ? document.body.scrollHeight : 0) - window.innerHeight;
        return h <= 0 ? 100 : Math.min(100, Math.round(window.scrollY / h * 100));
      }
      function fire(trigger) {
        if (fired) return;
        fired = true;
        clearInterval(iv);
        attempt(trigger);
      }
      var iv = setInterval(function () {
        maxPct = Math.max(maxPct, pct());
        if (now() - t0 >= delay && maxPct >= need) fire('time');
      }, 250);
      cleanups.push(function () { clearInterval(iv); });
      if (cfg.trigger && cfg.trigger.exitIntent && !isMobile) exitIntent(function () { fire('exit'); }, 3000);
    }
    // Second chance: once per visitor per wait period, only when they look like they are leaving.
    var secondArmed = false;
    function armSecondChance() {
      var S = cfg.second || {};
      if (secondArmed || !S.on || state.second || sess.second || submitted) return;
      secondArmed = true;
      var afterMs = Math.max(0, num(S.afterS, 30)) * 1000;
      var fired = false;
      function ready() {
        // Long enough since the close, and not straight after it on the same page.
        return !fired && !open && now() - (state.closedAt || 0) >= afterMs &&
          (window.location.pathname !== state.closedPath || now() - (state.closedAt || 0) >= 2 * afterMs);
      }
      function fire(trigger) {
        if (!ready()) return;
        fired = true;
        shownThisPage = false;                     // allow this one extra open on this page
        attempt(trigger, function () { save({ second: 1 }); saveSess({ second: 1 }); });
      }
      if (!isMobile) { exitIntent(function () { fire('second_exit'); }, 0); return; }
      if (isProduct) return;                       // scrolling up there usually means heading for the buy button
      // Mobile: a quick flick back up most of the way to the top after having read down the page.
      var samples = [];
      var deepest = 0;
      on(window, 'scroll', function () {
        var y = window.scrollY, t = now();
        deepest = Math.max(deepest, y);
        samples.push([t, y]);
        while (samples.length && t - samples[0][0] > 600) samples.shift();
        var peak = 0;
        for (var i = 0; i < samples.length; i++) peak = Math.max(peak, samples[i][1]);
        if (deepest > window.innerHeight && peak - y > window.innerHeight * 0.8 && y < deepest * 0.35) fire('second_flick');
      }, { passive: true });
    }

    /* ---------- test bar ---------- */
    var bar = null;
    var barReady = false;                          // not before the state above is complete
    function testBar() {
      if (!TEST || EDITOR || !barReady) return;
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'plk-testbar';
        var u = function (v) { var x = new URL(window.location.href); x.searchParams.set('plk', v); return x.toString(); };
        bar.innerHTML = '<b>Popup test</b> <span data-s></span> <a href="' + u('reset') + '">Reset</a> <a href="' + u('off') + '">Exit test</a>';
        document.body.appendChild(bar);
      }
      var s = submitted ? 'signed up (never shows again)'
        : state.closedAt ? (state.played ? 'won, closed: widget + one second chance' : 'closed: widget + one second chance') + (state.second ? ' (used)' : '')
        : state.played ? 'won, no email yet: reopens at the email step'
        : 'new visitor: opens after ' + V.delayS + ' s';
      bar.querySelector('[data-s]').textContent = '· ' + s + (test ? ' · variant ' + variant : '') + ' · ' + GAME + ' ·';
    }

    var api = {
      destroy: function () {
        cleanups.forEach(function (fn) { fn(); });
        timers.forEach(clearTimeout);
        clearTimeout(closeTimer);
        clearTimeout(flushTimer);
        game.pause();
        if (open) { html.style.overflow = prevOverflow; html.classList.remove('plk-open'); }
        open = false;
        if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
      }
    };

    if (EDITOR) {
      // Theme editor: show it while the section or one of its blocks is selected.
      var mine = function (e) { return e.detail && e.detail.sectionId === cfg.section; };
      on(document, 'shopify:section:select', function (e) { if (mine(e)) { state = {}; show('editor'); } });
      on(document, 'shopify:block:select', function (e) { if (mine(e)) { state = {}; show('editor'); } });
      on(document, 'shopify:section:deselect', function (e) { if (mine(e)) hide(); });
      return api;
    }

    barReady = true;
    testBar();
    if (submitted) return api;
    if (identitySkip()) return api;
    if (sess.yield) {                              // stepped aside for the cart this session
      klaviyoKnown().then(function (known) { if (!known) showWidget(1200); });
      return api;
    }
    if (state.closedAt) {
      klaviyoKnown().then(function (known) {
        if (known) return;
        showWidget(1200);
        armSecondChance();
      });
      return api;
    }
    armFirst();
    return api;
  }

  /* ---------- Scratch card ----------
     A canvas cover over the prize text. The visitor scratches it away with a
     mouse or a finger (pointer events, the page does not scroll while
     scratching). The cover is the configured image, drawn to fill the card, or
     without one a warm gradient with the label. When the share of cleared
     pixels reaches the threshold the cover fades and onWin runs. Keyboard:
     the card is focusable and Enter or Space reveals it. */
  function createScratch(o) {
    var card = o.card, cv = o.canvas;
    var ctx = cv && cv.getContext ? cv.getContext('2d', { willReadFrequently: true }) : null;
    var W = 0, H = 0, inited = false, started = false, revealed = false, active = false, last = null, pending = false;
    var strokes = 0, tries = 0, img = null;
    var brush = clamp(Number(o.brush) || 20, 6, 60);
    var need = clamp((Number(o.pct) || 40) / 100, 0.1, 0.95);

    function paintFallback() {
      var g = ctx.createLinearGradient(0, 0, W, H);
      g.addColorStop(0, '#f7daa5'); g.addColorStop(0.5, '#fbe7bf'); g.addColorStop(1, '#f2cf8f');
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);
      if (o.label) {
        ctx.fillStyle = 'rgba(31, 27, 19, .55)';
        ctx.font = '700 ' + Math.max(16, Math.round(W / 12)) + 'px ' + (window.getComputedStyle(card).fontFamily || 'sans-serif');
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(String(o.label).toUpperCase(), W / 2, H / 2);
      }
    }
    function paintImage() {
      var ar = img.naturalWidth / img.naturalHeight, car = W / H, sx, sy, sw, sh;
      if (ar > car) { sh = img.naturalHeight; sw = sh * car; sx = (img.naturalWidth - sw) / 2; sy = 0; }
      else { sw = img.naturalWidth; sh = sw / car; sx = 0; sy = (img.naturalHeight - sh) / 2; }
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, W, H);
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, W, H);
    }
    function paint() { if (img && img.complete && img.naturalWidth) paintImage(); else paintFallback(); }
    function size() {
      var r = card.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) return false;
      var dpr = Math.min(2.5, window.devicePixelRatio || 1);
      W = r.width; H = r.height;
      cv.width = Math.round(W * dpr);
      cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      return true;
    }
    function point(e) { var r = cv.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    function erase(pt) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = brush * 2;
      if (last) { ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(pt.x, pt.y); ctx.stroke(); }
      ctx.beginPath();
      ctx.arc(pt.x, pt.y, brush, 0, Math.PI * 2);
      ctx.fill();
      last = pt;
      strokes++;
      if (!pending) { pending = true; setTimeout(check, 120); }
    }
    function check() {
      pending = false;
      if (revealed) return;
      var d;
      try { d = ctx.getImageData(0, 0, cv.width, cv.height).data; }
      catch (e) { if (strokes > 60) reveal(); return; }   // cover from a host without CORS: reveal by effort instead
      var clear = 0, total = 0;
      for (var i = 3; i < d.length; i += 4 * 64) { total++; if (d[i] < 40) clear++; }
      if (total && clear / total >= need) reveal();
    }
    function begin() {
      if (started) return;
      started = true;
      if (typeof o.onStart === 'function') o.onStart();
    }
    function reveal() {
      if (revealed) return;
      revealed = true;
      begin();
      cv.classList.add('is-revealed');
      setTimeout(function () { cv.style.display = 'none'; }, 500);
      if (typeof o.onWin === 'function') o.onWin();
    }
    function down(e) {
      if (revealed) return;
      e.preventDefault();
      active = true;
      last = null;
      try { cv.setPointerCapture(e.pointerId); } catch (x) {}
      begin();
      erase(point(e));
    }
    function move(e) { if (!active || revealed) return; e.preventDefault(); erase(point(e)); }
    function up() { active = false; last = null; }
    function init() {
      if (inited || revealed) return;
      if (!ctx || !card) { revealed = true; if (typeof o.onWin === 'function') o.onWin(); return; }
      if (!size()) { if (tries++ < 40) window.requestAnimationFrame(init); return; }
      inited = true;
      paintFallback();
      if (o.cover) {
        img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { if (!started) paintImage(); };
        img.src = o.cover;
      }
      cv.setAttribute('tabindex', '0');
      cv.setAttribute('role', 'button');
      cv.addEventListener('pointerdown', down);
      cv.addEventListener('pointermove', move);
      cv.addEventListener('pointerup', up);
      cv.addEventListener('pointercancel', up);
      cv.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); reveal(); } });
      window.addEventListener('resize', function () { if (!started && size()) paint(); });
    }
    return { start: init, pause: function () {}, idle: function () { return !started; }, drop: function () {} };
  }

  /* ---------- Plinko board ----------
     Galton-board geometry (from the HYDRAW popup): peg row r (0-based) has r + 2
     pegs one unit apart, centred, so the bottom of R rows spans -(R/2)..R/2 and
     the slot walls span one unit wider, S = R + 1, split evenly between the
     slots. The ball falls through the gap in row 0 onto the centre peg of row 1
     and deflects half a unit left or right after every row; with R - 1
     deflections it ends at (rights - lefts) / 2, so the number of rights is
     picked to end inside the winning slot and shuffled into a natural path. */
  function createGame(o) {
    var board = o.board, cv = o.canvas, slotsEl = o.slots;
    var ctx = cv && cv.getContext ? cv.getContext('2d') : null;
    var slotEls = slotsEl ? Array.prototype.slice.call(slotsEl.children) : [];
    var N = Math.max(1, slotEls.length);
    var R = clamp(parseInt(o.rows, 10) || 6, 5, 9);
    var S = R + 1;
    var win = clamp((parseInt(o.win, 10) || 1) - 1, 0, N - 1);
    var speedF = 100 / clamp(Number(o.speed) || 100, 40, 200);
    var C = null;
    var G = null;
    var hits = {};
    var trail = [];
    var particles = [];
    var ball = null;
    var phase = 'idle';            // idle -> dropping -> done
    var segs = [];
    var t0 = 0;
    var raf = 0;
    var running = false;
    var landed = false;
    var landX = 0;

    function colors() {
      var css = window.getComputedStyle(board);
      function col(name, fb) { return (css.getPropertyValue(name) || '').trim() || fb; }
      return { peg: col('--plk-peg', '#11110f'), ball: col('--plk-ball', '#11110f'), accent: col('--plk-accent', '#d78a00') };
    }

    function layout() {
      if (!ctx) return;
      var W = board.clientWidth || 320;
      var sp = W / (S + 1);
      var rowGap = sp * 0.92;
      var top = sp * 1.3;
      var wallTop = top + (R - 1) * rowGap + rowGap * 0.55;
      var slotH = Math.max(58, sp * 1.3);
      var H = Math.round(wallTop + slotH);
      var dpr = Math.min(2.5, window.devicePixelRatio || 1);
      cv.width = Math.round(W * dpr);
      cv.height = Math.round(H * dpr);
      cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      slotsEl.style.left = (W / 2 - (S / 2) * sp) + 'px';
      slotsEl.style.width = (S * sp) + 'px';
      slotsEl.style.top = wallTop + 'px';
      slotsEl.style.height = slotH + 'px';
      G = {
        W: W, H: H, sp: sp, rowGap: rowGap, top: top, wallTop: wallTop, slotH: slotH,
        pegR: Math.max(2.2, sp * 0.065), ballR: Math.max(5, sp * 0.16),
        px: function (x) { return W / 2 + x * sp; }, py: function (r) { return top + r * rowGap; }
      };
      G.walls = [];
      for (var i = 0; i <= N; i++) G.walls.push(-S / 2 + i * (S / N));
      if (phase === 'idle') ball = { x: G.px(0), y: top - rowGap * 0.8 };
      else if (phase === 'done') ball = { x: G.px(landX), y: G.wallTop + G.ballR + 4 };
    }

    function buildPath() {
      var steps = R - 1;
      var a = -S / 2 + win * (S / N), b = a + S / N, mid = (a + b) / 2;
      var cand = [], k, i;
      for (k = 0; k <= steps; k++) { var x0 = k - steps / 2; if (x0 > a + 1e-6 && x0 < b - 1e-6) cand.push(k); }
      if (!cand.length) {
        var best = 0, bestD = Infinity;
        for (k = 0; k <= steps; k++) { var d = Math.abs(k - steps / 2 - mid); if (d < bestD) { bestD = d; best = k; } }
        cand = [best];
      }
      k = cand[Math.floor(Math.random() * cand.length)];
      var dirs = [];
      for (i = 0; i < steps; i++) dirs.push(i < k ? 1 : -1);
      for (i = dirs.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var tmp = dirs[i]; dirs[i] = dirs[j]; dirs[j] = tmp; }

      function contact(x, r) { return { x: G.px(x), y: G.py(r) - G.pegR - G.ballR, row: r, peg: x }; }
      var list = [];
      var x = 0;
      var c = contact(0, 1);
      list.push({ from: { x: ball.x, y: ball.y }, to: c, dur: 420 * speedF, kind: 'fall' });
      for (var r = 1; r < R - 1; r++) {
        x += dirs[r - 1] * 0.5;
        var n = contact(x, r + 1);
        list.push({ from: c, to: n, dur: Math.max(150, 250 - r * 9) * speedF, kind: 'hop', hit: c });
        c = n;
      }
      landX = mid;
      var land = { x: G.px(mid), y: G.wallTop + G.ballR + 4 };
      list.push({ from: c, to: land, dur: 480 * speedF, kind: 'land', hit: c });
      list.push({ from: land, to: land, dur: 360 * speedF, kind: 'settle' });
      return list;
    }

    function burst(x, y) {
      if (!o.confetti || o.reduceMotion) return;
      var cols = [C.accent, C.ball, '#ffffff', C.accent, '#e9b872'];
      var now = performance.now();
      for (var i = 0; i < 36; i++) {
        var ang = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.1;
        var v = (2.4 + Math.random() * 3.6) * (G.sp / 46);
        particles.push({ x: x, y: y, vx: Math.cos(ang) * v, vy: Math.sin(ang) * v, rot: Math.random() * 6, vr: (Math.random() - 0.5) * 0.4,
          s: (3 + Math.random() * 4) * (G.sp / 46), c: cols[i % cols.length], born: now, life: 900 + Math.random() * 500 });
      }
    }

    function draw(now) {
      ctx.clearRect(0, 0, G.W, G.H);
      var i, r;
      // slot walls: plain thin lines
      ctx.save();
      ctx.strokeStyle = C.peg;
      ctx.globalAlpha = 0.25;
      ctx.lineWidth = 1;
      for (i = 0; i < G.walls.length; i++) {
        var wx = Math.round(G.px(G.walls[i])) + 0.5;
        ctx.beginPath();
        ctx.moveTo(wx, G.wallTop);
        ctx.lineTo(wx, G.H - 2);
        ctx.stroke();
      }
      ctx.restore();
      // pegs, flashing when hit
      for (r = 0; r < R; r++) {
        for (i = 0; i < r + 2; i++) {
          var x = i - (r + 1) / 2;
          var t = hits[r + ':' + x];
          var e = t ? Math.max(0, 1 - (now - t) / 320) : 0;
          if (e > 0) {
            ctx.beginPath();
            ctx.fillStyle = C.accent;
            ctx.globalAlpha = 0.55 * e;
            ctx.arc(G.px(x), G.py(r), G.pegR * (1.6 + 2.2 * (1 - e)), 0, Math.PI * 2);
            ctx.fill();
            ctx.globalAlpha = 1;
          }
          ctx.beginPath();
          ctx.fillStyle = C.peg;
          ctx.arc(G.px(x), G.py(r), G.pegR * (1 + 0.45 * e), 0, Math.PI * 2);
          ctx.fill();
        }
      }
      // trail
      for (i = 0; i < trail.length; i++) {
        var f = (i + 1) / trail.length;
        ctx.beginPath();
        ctx.fillStyle = C.ball;
        ctx.globalAlpha = 0.16 * f;
        ctx.arc(trail[i].x, trail[i].y, G.ballR * (0.45 + 0.5 * f), 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      // ball, bobbing gently before the drop
      if (ball) {
        var bob = phase === 'idle' && !o.reduceMotion ? Math.sin(now / 380) * G.sp * 0.07 : 0;
        ctx.beginPath();
        ctx.fillStyle = C.ball;
        ctx.arc(ball.x, ball.y + bob, G.ballR, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();
        ctx.fillStyle = 'rgba(255,255,255,0.3)';
        ctx.arc(ball.x - G.ballR * 0.35, ball.y + bob - G.ballR * 0.35, G.ballR * 0.32, 0, Math.PI * 2);
        ctx.fill();
      }
      // confetti
      particles = particles.filter(function (p) { return now - p.born < p.life; });
      for (i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.vy += 0.16 * (G.sp / 46); p.vx *= 0.985; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - (now - p.born) / p.life);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.c;
        ctx.fillRect(-p.s / 2, -p.s / 3, p.s, p.s * 0.66);
        ctx.restore();
      }
    }

    function stepDrop(now) {
      var t = now - t0;
      for (var i = 0; i < segs.length; i++) {
        var s = segs[i];
        if (t > s.dur) {
          if (!s.passed) {
            s.passed = true;
            var nxt = segs[i + 1];
            if (nxt && nxt.hit) hits[nxt.hit.row + ':' + nxt.hit.peg] = now;
            if (s.kind === 'land') onLanded();
          }
          t -= s.dur;
          continue;
        }
        var u = t / s.dur;
        if (s.kind === 'fall') {
          ball = { x: s.from.x + (s.to.x - s.from.x) * u, y: s.from.y + (s.to.y - s.from.y) * u * u };
        } else if (s.kind === 'hop' || s.kind === 'land') {
          var ex = 1 - (1 - u) * (1 - u);
          var arc = (s.kind === 'land' ? G.rowGap * 0.3 : G.rowGap * 0.34) * Math.sin(Math.PI * u) * (1 - u);
          ball = { x: s.from.x + (s.to.x - s.from.x) * ex, y: s.from.y + (s.to.y - s.from.y) * u * u - arc };
        } else {
          var bb = Math.abs(Math.sin(u * Math.PI * 2)) * (1 - u) * G.sp * 0.16;
          ball = { x: s.to.x, y: s.to.y - bb };
        }
        return true;
      }
      var last = segs[segs.length - 1];
      ball = { x: last.to.x, y: last.to.y };
      return false;
    }

    function onLanded() {
      if (landed) return;
      landed = true;
      for (var i = 0; i < slotEls.length; i++) slotEls[i].classList.add(i === win ? 'is-win' : 'is-dim');
      burst(ball.x, ball.y);
      try { if (navigator.vibrate) navigator.vibrate(28); } catch (e) {}
    }

    function finish() {
      phase = 'done';
      board.removeAttribute('data-dropping');
      board.setAttribute('data-done', '');
      if (typeof o.onWin === 'function') o.onWin();
    }

    function frame(now) {
      if (phase === 'dropping') {
        if (ball) { trail.push({ x: ball.x, y: ball.y }); if (trail.length > 9) trail.shift(); }
        if (!stepDrop(now)) finish();
      } else if (trail.length) {
        trail.shift();
      }
      draw(now);
      var busy = phase === 'dropping' || particles.length || trail.length;
      if (o.isOpen() && (phase === 'idle' || busy)) raf = window.requestAnimationFrame(frame);
      else running = false;
    }

    function start() {
      if (!ctx) return;
      if (!C) C = colors();
      if (!G || phase !== 'dropping') layout();
      if (!running) { running = true; raf = window.requestAnimationFrame(frame); }
    }
    function pause() { if (raf) window.cancelAnimationFrame(raf); raf = 0; running = false; }

    var rT = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () {
        if (!ctx || !G || phase === 'dropping' || !o.isOpen()) return;
        layout();
        draw(performance.now());
      }, 120);
    });

    return {
      idle: function () { return phase === 'idle'; },
      start: start,
      pause: pause,
      drop: function () {
        if (phase !== 'idle') return;
        if (!ctx) { phase = 'done'; if (typeof o.onWin === 'function') o.onWin(); return; }
        if (!C) C = colors();
        if (!G) layout();
        phase = 'dropping';
        board.setAttribute('data-dropping', '');
        segs = buildPath();
        if (o.reduceMotion) {
          var last = segs[segs.length - 1];
          ball = { x: last.to.x, y: last.to.y };
          onLanded();
          draw(performance.now());
          finish();
          return;
        }
        t0 = performance.now();
        if (!running) { running = true; raf = window.requestAnimationFrame(frame); }
      }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-plk]')) boot();
  });
})();
